import React from 'react'
import './breadcrumb.css'
import SelectGrades from './../Select/SelectGrades'

const Breadcrumb = ({ changeSelectSegment, items, root, filterGradeId }) => {
  const optionsSelect = items.map((item, index) => ({ value: index, label: item.name }))

  return (
    <div>
      <ul className='breadcrumb'>
        <li className='is-active' style={{ float: 'left' }}>
          <SelectGrades
            options={optionsSelect}
            changeSelectSegment={changeSelectSegment}
            filterGradeId={filterGradeId}
          />
        </li>
      </ul>
    </div>
  )
}

export default Breadcrumb



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/index.js